export default {
    job: {
        seekers: 'Seekers',
    },
};
